package sarka.design.skoria.ui.composables

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsFocusedAsState
import androidx.compose.foundation.layout.Column
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.material3.TextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.input.VisualTransformation
import org.jetbrains.compose.ui.tooling.preview.Preview
import sarka.design.skoria.ui.theme.RCTheme

@Composable
fun SkoriaTextField(
    title: String? = null,
    value: String? = null,
    onValueChange: ((String) -> Unit)? = null,
    errorText: String? = null,
    hint: String? = null,
    isPassword: Boolean = false,
    enabled: Boolean = true,
    modifier: Modifier = Modifier
) {
    // If onValueChange is provided, use controlled mode (external state).
    // Otherwise, use internal state for backward compatibility.
    val isControlled = onValueChange != null
    var internalText by remember { mutableStateOf("") }
    val displayText = if (isControlled) (value ?: "") else internalText

    val interactionSource = remember { MutableInteractionSource() }
    val isFocused by interactionSource.collectIsFocusedAsState()

    Column(modifier = modifier) {
        title?.let {
            Text(title)
        }

        TextField(
            singleLine = true,
            enabled = enabled,
            visualTransformation = if (isPassword) PasswordVisualTransformation('*') else VisualTransformation.None,
            value = displayText,
            onValueChange = { newValue ->
                if (isControlled) {
                    onValueChange.invoke(newValue)
                } else {
                    internalText = newValue
                }
            },
            interactionSource = interactionSource,
            colors = TextFieldDefaults.colors(),
            placeholder = {
                hint?.let {
                    Text(
                        hint,
                        color = if (isFocused) MaterialTheme.colorScheme.primary
                               else MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
            }
        )
        errorText?.let {
            Text(
                text = errorText,
                color = MaterialTheme.colorScheme.error,
                style = MaterialTheme.typography.bodySmall
            )
        }
    }
}


@Composable
@Preview
fun SkoriaTextFieldPreview() {
    RCTheme {
        Surface {
            Column {
                SkoriaTextField(
                    title = "Username:",
                    value = "John",
                )
                SkoriaTextField(
                    value = "",
                    hint = "Username"
                )
                SkoriaTextField(
                    value = "this is some password",
                    hint = "Username",
                    isPassword = true
                )
            }
        }
    }
}
